import { CALayoutState, LAYOUT_GETTER_ANCHO_SIDEMENU, LAYOUT_GETTER_LOADING, LAYOUT_GETTER_MODAL_ACTIVO, LAYOUT_GETTER_SNACK_ACTIVO, LAYOUT_MUTATION_CERRAR_MODAL, LAYOUT_MUTATION_LOADING, LAYOUT_MUTATION_MODAL, LAYOUT_MUTATION_MODAL_ADVERTENCIA, LAYOUT_MUTATION_MODAL_ERROR, LAYOUT_MUTATION_MODAL_EXITO, LAYOUT_MUTATION_MOSTRAR_LOADING, LAYOUT_MUTATION_OCULTAR_LOADING, LAYOUT_MUTATION_OCULTAR_SNACKBAR, LAYOUT_MUTATION_SNACKBAR_ERROR, LAYOUT_MUTATION_SNACKBAR_EXITO } from './layout.types';

const state: CALayoutState = {
  modal_activo: null,
  snack_activo: null,
  loading: false
};

const getters = {
  [LAYOUT_GETTER_MODAL_ACTIVO](state: CALayoutState) {
    return state.modal_activo || {};
  },
  [LAYOUT_GETTER_SNACK_ACTIVO](state: CALayoutState) {
    return state.snack_activo || {};
  },
  [LAYOUT_GETTER_LOADING](state: CALayoutState) {
    return state.loading;
  },
  [LAYOUT_GETTER_ANCHO_SIDEMENU]() {
    return 0;
  }
};

const mutations = {
  /**
   * Abre modal genérico, se puede setear tipo, titulo, texto y detalle.
   *
   * @param state
   * @param payload
   */
  [LAYOUT_MUTATION_MODAL](state: CALayoutState, payload) {
    state.modal_activo={
      mostrar: true,
      tipo: payload.tipo,
      texto: payload.texto,
      titulo: payload.titulo,
    };
  },
  /**
   * Abre modal de error, se puede setear titulo, texto y detalle.
   * Si no se setea titulo defaultea a ERROR
   *
   * @param state
   * @param payload
   */
  [LAYOUT_MUTATION_MODAL_ERROR](state: CALayoutState, payload) {
    state.modal_activo = {
      mostrar: true,
      tipo: 'error',
      texto: payload.texto,
      detalle: payload.detalle,
      titulo: payload.titulo || 'ERROR'
    };
  },
  /**
   * Abre modal de éxito, se puede setear titulo y texto.
   * Si no se setea titulo defaultea a EXITO
   *
   * @param state
   * @param payload
   */
  [LAYOUT_MUTATION_MODAL_EXITO](state: CALayoutState, payload) {
    state.modal_activo = {
      mostrar: true,
      tipo: 'exito',
      texto: payload.texto,
      titulo: payload.titulo || 'ÉXITO'
    };
  },
  /**
   * Abre modal de éxito, se puede setear titulo y texto.
   * Si no se setea titulo defaultea a EXITO
   *
   * @param state
   * @param payload
   */
  [LAYOUT_MUTATION_MODAL_ADVERTENCIA](state: CALayoutState, payload) {
    state.modal_activo = {
      mostrar: true,
      tipo: 'warning',
      texto: payload.texto,
      detalle: payload.detalle,
      titulo: payload.titulo || 'ATENCIÓN'
    };
  },
  /**
   * Cierre del modal activo.
   * @param state
   */
  [LAYOUT_MUTATION_CERRAR_MODAL](state: CALayoutState) {
    if (!state.modal_activo)
      return;
    state.modal_activo.mostrar = false;
  },
  /**
   * Muestra snackbar de éxito en la parte inferior de la pantalla.
   * En payload se envía string con el texto a mostrar.
   *
   * @param state
   * @param payload
   */
  [LAYOUT_MUTATION_SNACKBAR_EXITO](state: CALayoutState, payload) {
    state.snack_activo = {
      mostrar: true,
      error: false,
      texto: payload
    };
  },
  /**
   * Muestra snackbar de error en la parte inferior de la pantalla.
   * En payload se envía string con el texto a mostrar.
   *
   * @param state
   * @param payload
   */
  [LAYOUT_MUTATION_SNACKBAR_ERROR](state: CALayoutState, payload) {
    state.snack_activo = {
      mostrar: true,
      error: true,
      texto: payload
    };
  },
  /**
   * Oculta snackbar activo
   *
   * @param state
   */
  [LAYOUT_MUTATION_OCULTAR_SNACKBAR](state: CALayoutState) {
    if (!state.snack_activo)
      return;
    state.snack_activo.mostrar = false;
  },
  /**
   * Setea el estado del loading con el valor pasado en payload (boolean):
   * * Si se quiere mostrar el loading se pasa true
   * * Si se quiere ocultar el loading se pasa false
   *
   * @param state
   * @param payload
   */
  [LAYOUT_MUTATION_LOADING](state: CALayoutState, payload) {
    state.loading = payload;
  },
  [LAYOUT_MUTATION_MOSTRAR_LOADING](state: CALayoutState) {
    state.loading = true;
  },
  [LAYOUT_MUTATION_OCULTAR_LOADING](state: CALayoutState) {
    state.loading = false;
  }
};

export default {
  state,
  mutations,
  getters
};
